import React, { useEffect, useState } from 'react';
import { whoami } from '../services/auth.js';
import { useGlobalState } from '../hooks/useGlobalState.js';
import { config } from '../config/index.js';
import { useNavigate } from 'react-router-dom';
const { API_BASE_URL } = config;

const AuthRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { updateUserProfile } = useGlobalState();
  useEffect(() => {
    whoami().then((res) => {
      if (res == null) {
        const currentHostname = window.location.hostname;
        if (currentHostname === 'admin-dev.scams.report' || currentHostname === 'admin.scams.report' ) {
          window.location.href = `${API_BASE_URL}/saml2/authenticate/aws-sso`;
        } else if (currentHostname === 'sr-dev.antiscam.center' || currentHostname === 'sr.antiscam.center' ) {
          navigate('/');
        }
        setIsAuthenticated(false);
      } else {
        updateUserProfile(res);
        setIsAuthenticated(true);
      }
      setIsLoading(false);
    });
  }, []);

  if (isLoading) return <div>加载中...</div>;

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return null;
};


export default AuthRoute;
